var x = Object.defineProperty;
var q = (r, e, s) => e in r ? x(r, e, { enumerable: !0, configurable: !0, writable: !0, value: s }) : r[e] = s;
var u = (r, e, s) => q(r, typeof e != "symbol" ? e + "" : e, s);
import { CONFIG as c } from "@packages/config";
import { Injectable as g, Inject as m } from "@webmotors/ioc";
import y from "axios";
import "./main77.js";
import { LOGGER as v } from "./main78.js";
import { NoResponseError as C } from "./main213.js";
import { ServerError as P } from "./main214.js";
import { HttpMethod as b } from "./main81.js";
import { HTTP as j } from "./main82.js";
var E = Object.getOwnPropertyDescriptor, O = (r, e, s, a) => {
  for (var o = a > 1 ? void 0 : a ? E(e, s) : e, t = r.length - 1, i; t >= 0; t--)
    (i = r[t]) && (o = i(o) || o);
  return o;
}, l = (r, e) => (s, a) => e(s, a, r);
let w = class {
  constructor(r, e) {
    u(this, "logger");
    this.config = r, this.loggerFactory = e, this.logger = this.loggerFactory.create("Http");
  }
  async isPerimeterexError(r) {
    var n, p, h;
    if (!r || typeof r != "object")
      return !1;
    const e = r;
    if (((n = e.response) == null ? void 0 : n.status) !== 403)
      return !1;
    const a = ((p = e.response) == null ? void 0 : p.headers) || {}, o = (h = e.response) == null ? void 0 : h.data, t = Object.keys(a).some(
      (d) => d.toLowerCase().startsWith("px-") || d.toLowerCase().includes("perimeterx")
    ), i = o && typeof o == "object" && ("appId" in o || "uuid" in o);
    return t || !!i;
  }
  async request(r, e) {
    var o;
    const s = {
      method: (e == null ? void 0 : e.method) ?? b.GET,
      url: r,
      params: (e == null ? void 0 : e.params) ?? {},
      headers: this.config.disabledHeaders ? {} : (e == null ? void 0 : e.headers) ?? {}
      // data: config?.body ?? {},
    };
    e != null && e.body && ((o = e == null ? void 0 : e.headers) == null ? void 0 : o["Content-Type"]) === "application/json" && (s.data = JSON.parse(e.body.toString())), this.logger.info("[request] sending request: ", r), this.logger.info("[request] request config: ", e);
    const a = y.create();
    try {
      this.logger.info("[request] axiosConfig: ", s);
      const t = await a.request(s);
      return this.logger.info("[request] response status text: ", t.statusText), this.logger.info("[request] response status code: ", t.status), this.logger.info("[request] response data: ", t.data), t.data;
    } catch (t) {
      if (this.logger.error("[request] something went wrong", t), await this.isPerimeterexError(t))
        throw this.logger.error("[request] Perimeterex error detected", t), t;
      if (t.response) {
        const i = t.response.data;
        throw this.logger.error("[request] something went wrong", i), new P(i);
      }
      throw t.request ? new C("No response received") : t;
    }
  }
};
w = O([
  g(j),
  l(0, m(c)),
  l(1, m(v))
], w);
export {
  w as AxiosService
};
